import { Button, Col, Form, Row, Space } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import InputBox from "../../../../components/common/input";
import CommonUpload from "../../../../components/common/upload-image";
import FileUploadTwo from "../../../../components/common/fileUploadFun/FileUploadTwo";
import { useDispatch, useSelector } from "react-redux";
import {
  addAuthor,
  updateAuthor,
  viewAuthor,
} from "../../../../redux/reducer/authorSlice";
import { toast } from "react-toastify";
import AudioUpload from "../../../../components/common/audio-upload/AudioUpload";
import { uploadFile } from "../../../../redux/reducer/UploadSlice";
import { DefaultPodcast, updateDefaultPodcast } from "../../../../redux/reducer/ManagePodcastSlice";


const AddAudio = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const {DefPodcastsData,  updateDefPodcastData,
        updateDefPodcastLoading,
        updateDefPodcastError } = useSelector((prev) => prev?.managePodcast)
    
    const dispatch = useDispatch()
    const location = useLocation();
    const [audioFilesLinks, setAudioFileLinks] = useState({
        file_url_en: "",  
      });
    

    const handleUploadSuccess = (field, url) => {
        form.setFieldsValue({ [field]: url });
      };


      useEffect(()=>{
       dispatch(DefaultPodcast()) 
      },[dispatch])



  const audioUploadEn = async (file) => {
    const data = await dispatch(uploadFile(file));
    setAudioFileLinks((prev) => ({
      ...prev,
      file_url_en: data?.payload?.result?.rows?.[0]?.image_url,
    }));
  };

  

      const handleSubmit = async (value) => {
        if(audioFilesLinks.file_url_en === ""){
            toast.error("Please Upload a New File")
        }

       const  response = await dispatch(
        updateDefaultPodcast({ 
                id: 1,     
                file_url_en: audioFilesLinks.file_url_en })
          );

          if(response.type === "data/update/podcast/default/fulfilled"){
            toast.success("Audio Updated Succesfully")
          }

      }
    


  return (
    <div>
      <div className="addBtnBx dflex">
        <div className="tableHeading">
           Add Default Audio
        </div>
        <Space>
          <Button onClick={() => navigate(-1)}>Cancel</Button>
          <Button type="primary" loading={updateDefPodcastLoading} onClick={() => form.submit()}>
            Save Details
          </Button>
        </Space>
      </div>
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Row gutter={16}>
          <Col xs={24} sm={24}>
            <Row gutter={16}>
           
           
            
            <Col xs={24} sm={8}>
            <Form.Item
              name="file_url_en"
              label="Upload Default audio"
            //   rules={[
            //     {
            //       required: true,
            //       validator: async () => {
            //         if (!audioFilesLinks.file_url_en) {
            //           return Promise.reject(
            //             // new Error("Please upload an audio file (es)")
            //           );
            //         }
            //       },
            //     },
            //   ]}
            >
              <AudioUpload
                // onDurationExtracted={(dur) =>
                //   setAudioDuration((prev) => ({
                //     ...prev,
                //     duration_es: Math.floor(dur),
                //   }))
                // }
                onFileUpload={audioUploadEn}
                audioSrc={
                //   editData
                     `${process.env.REACT_APP_IMAGE_URL}/${DefPodcastsData?.file_url_en}`
                  
                }
              />
            </Form.Item>
          </Col>{" "}
            
              
            </Row>
          </Col>
        </Row>
      </Form>
    </div>
  )
}

export default AddAudio